module.exports = __webpack_public_path__ + "img/005李辉.77477167.png";